export default __webpack_public_path__ + "static/media/atuacao_img_2.2cbab9c0.svg";